import { Contract } from './contract';
import { LeaseAgreementCategory, OrganizationOfTenantsKind } from './const/enums';
import { DwellingInspection } from '../../dwelling-inspection/model/dwelling-inspection';
import { SubleaseRequest } from './sublease-request';

export class DwellingContract extends Contract {
  constructor() {
    super(LeaseAgreementCategory.Dwelling);
    this.allowEntranceWithExtraKey = true;
    this.dwellingInspections = [];
    this.subleaseRequests = [];
    this.organizationOfTenants = OrganizationOfTenantsKind.None;
    this.nameplate = '';
  }

  private _subleaseRequest: SubleaseRequest[] = [];

  get subleaseRequests(): SubleaseRequest[] {
    return this._subleaseRequest;
  }
  set subleaseRequests(items: SubleaseRequest[]) {
    if (items instanceof Array) {
      items.forEach(item => {
        if (item instanceof SubleaseRequest) this._subleaseRequest.push(item);
        else this._subleaseRequest.push(Object.assign(new SubleaseRequest(), item));
      });
    }
  }

  nameplate: string;
  allowEntranceWithExtraKey: boolean;
  atticStorageNumber: string;
  basementStorageNumber: string;
  dwellingInspections: DwellingInspection[];
  otherStorageNumber: string;
  parkingIncludedInRent: string;
  currencyCode: string;
  building: string;

  toJSON() {
    let json = super.toJSON();
    json.subleaseRequests = this.subleaseRequests;

    return json;
  }
}
